import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  Spacer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Grid,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import AccountApi from "api/account";
import { convertToJalali } from "utils/helper";

const zarfiatMapping = {
  1: "Z1 4",
  2: "Z1 4",
  3: "Z2 4",
  4: "Z3 4",
  5: "Z3 4",
  6: "Z1 5",
  7: "Z1 5",
  8: "Z2 5",
  9: "Z3 5",
  10: "Z3 5"
};

const SalesHistoryModal = ({ isOpen, onClose, accountId }) => {
  const [salesHistory, setSalesHistory] = useState([]);

  useEffect(() => {
    if (isOpen && accountId) {
      const fetchSalesHistory = async () => {
        try {
          const response = await AccountApi.SalesHistory(accountId);
          setSalesHistory(response.data.data);
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      };
      fetchSalesHistory();
    }
  }, [isOpen, accountId]);

  const SalesHistorySlice = (index) => salesHistory.slice(0, index + 1);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>تاریخچه فروش</ModalHeader>
        <ModalCloseButton position="absolute" left="9px" right="auto" />
        <ModalBody p="0">
          <Grid
            templateColumns={{ base: "repeat(auto-fit, minmax(220px, 1fr))", lg: "repeat(4, 1fr)" }}
            gap="20px"
            p="20px"
            justifyItems="center"
            width="100%"
          >
            {salesHistory.map((sale, index) => {
              const causer = SalesHistorySlice(index).reverse().find(item => item.causer)?.causer;
              const date = SalesHistorySlice(index).reverse().find(item => item.causer)?.created_at;
              return (
                <Card key={sale.id} w="100%" borderWidth="1px" borderRadius="md" boxShadow="md" p="0">
                  <CardHeader
                    bg={"#2a72e3"}
                    color="white"
                    p="2"
                    borderRadius="md"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    minHeight="20px"
                  >
                    <Text wordBreak="break-word" textAlign="right">
                      {`#${index + 1}`} تعییر توسط {causer} <br/>
                      {convertToJalali(date)}
                    </Text>
                  </CardHeader>
                  <CardBody p="0" overflowY="scroll">
                    <Table variant="striped" w="100%" textAlign="center">
                      <Thead color="white">
                        <Tr>
                          <Th py="2" px="0" textAlign="center">پر؟</Th>
                          <Th py="2" px="0" textAlign="center" width="30%">سفارش</Th>
                          <Th py="2" px="0" textAlign="center">ظرفیت</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {Object.values(zarfiatMapping).map((value, i) => {
                          const matchingSale = SalesHistorySlice(index).reverse().find(item => item.subject.sharing_status_id === i + 1);
                          return (
                            <Tr key={i}>
                              <Td py="1">
                                {matchingSale?.properties?.attributes.is_full ? <>&#x2713;</> : ""}
                              </Td>
                              <Td py="1">{matchingSale?.properties?.attributes.worder_id}</Td>
                              <Td
                                px="0"
                                py="1"
                                textAlign="center"
                                color={value.includes("4") ? "#009182" : "#CC0B78"}
                              >
                                {value}
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </CardBody>
                </Card>
              );
            })}
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Flex width="100%" align="center">
            <Button variant="ghost" onClick={onClose} borderRadius="md">
              بستن
            </Button>
            <Spacer />
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SalesHistoryModal;
